import * as shippingsApi from "../../backend/shippingsApi.js";
import {
  getPhases,
  unmarkPhasesWithRerouting,
} from "../../backend/phasesApi.js";
import { eShippingStates } from "../../views/shippings/shipping-states.js";
import { unloadingPlaceTypes } from "../../enums/unloading-place-types.js";
import { getSettings } from "../../backend/settingsApi.js";
import { getData } from "../../backend/dataEditorApi.js";
import { phaseStates } from "../../views/shippings/components/phases/shipping-phase-states.js";
import { ePhaseTypes } from "../../views/shippings/components/phases/shipping-phase-types.js";

const state = {
  id: null,
  shipping: null,
  infoLoaded: true,
  infoItems: [],
  messages: [],
  messagesLoaded: true,
  notes: [],
  notesLoaded: true,
  attachments: [],
  attachmentsForExport: [],
  labels: [],
  dates: {
    readyToLoadDates: {
      request: "",
      plan: "",
      fact: "",
    },
    dateOfExportFromFactory: {
      request: "",
      plan: "",
      fact: "",
    },
    factoryClosing: {
      request: "",
      plan: "",
      fact: "",
    },
    deliveryToUnloading: {
      request: "",
      plan: "",
      fact: "",
    },
    shipmentFromStoreKiev: {
      request: "",
      plan: "",
      fact: "",
    },
  },
  versions: [],
  versionsLoaded: true,
  direction: {},
  shippingStates: [],
  state: 0,
  changeStateProccessedByServer: false,
  splitted: false,
  sender: null,
  senderAddress: null,
  phases: [],
  phasesLoading: false,
  isNonStandartExist: false,
  isPhaseActive: false,
  lastPhase: null,
  isPhasesDone: false,
  releaseOrders: [],
  releaseOrdersLoading: false,
  isReleaseOrderActive: false,
  client: null,
  isClient: false,
  compactMode: false,
  sameRegionShipping: 0,
  datesHeaders: [
    {
      text: "Даты",
      sortable: false,
    },
    {
      text: "Заявка",
      sortable: false,
    },
    {
      text: "План",
      sortable: false,
    },
    {
      text: "Факт",
      sortable: false,
    },
  ],
  phasesHeaders: [
    {
      text: "",
      sortable: false,
      align: "left",
    },
    {
      text: "",
      sortable: false,
      align: "left",
    },
    {
      text: "№",
      sortable: false,
      align: "left",
    },
    {
      text: "Статус",
      sortable: false,
      align: "left",
    },
    {
      text: "Тип",
      sortable: false,
      align: "left",
    },
    {
      text: "Отправка",
      sortable: false,
      align: "left",
    },
    {
      text: "Адрес погрузки",
      sortable: false,
      align: "left",
    },
    {
      text: "Дата прибытия",
      sortable: false,
      align: "left",
    },
    {
      text: "Прибытие",
      sortable: false,
      align: "left",
    },
    {
      text: "Адрес прибытия",
      sortable: false,
      align: "left",
    },
    {
      text: "Маршрут",
      sortable: false,
      align: "left",
    },
    {
      text: "Номер машины",
      sortable: false,
      align: "left",
    },
    {
      text: "Контрагент",
      sortable: false,
      align: "left",
    },
  ],
  releaseOrdersHeaders: [
    { text: "Id", sortable: false, align: "left" },
    { text: "Автор", sortable: false, align: "left" },
    { text: "Дата отгрузки", sortable: false, align: "left" },
    { text: "Номер поставки", sortable: false, align: "left" },
    { text: "Клиент", sortable: false, align: "left" },
    { text: "Продавец", sortable: false, align: "left" },
  ],
  allowedStates: [],
  isInRoute: false,
  goodsDetails: [],
  disabledState: false,
  isSplited: false,
  ourWarehouse: null,
  warehouseKievVolume: 0,
  packages: [],
  contactsLoading: [],
  manager: null,
  hasPickUpPhaseInRoute: false,
  isAllowEditPhase: false,
  isPhaseInCar: false,
  categoriesInfo: [],
  firstPhaseAllowEditing: false,
};

const getters = {
  id: (state) => {
    return state.id;
  },
  shipping: (state) => {
    return state.shipping;
  },
  infoLoaded: (state) => {
    return state.infoLoaded;
  },
  title: (state) => {
    return state.shipping ? state.shipping.Title : " ";
  },
  infoItems: (state) => {
    return state.infoItems;
  },
  messages: (state) => {
    return state.messages;
  },
  messagesLoaded: (state) => {
    return state.messagesLoaded;
  },
  notes: (state) => {
    return state.notes;
  },
  notesLoaded: (state) => {
    return state.notesLoaded;
  },
  attachments: (state) => {
    return state.attachments;
  },
  attachmentsForExport: (state) => {
    return state.attachmentsForExport;
  },
  labels: (state) => {
    return state.labels;
  },
  dates: (state) => {
    return state.dates;
  },
  versions: (state) => {
    return state.versions;
  },
  versionsLoaded: (state) => {
    return state.versionsLoaded;
  },
  direction: (state) => {
    return state.direction;
  },
  shippingStates: (state) => {
    return state.shippingStates;
  },
  state: (state) => {
    return state.state;
  },
  changeStateProccessedByServer: (state) => {
    return state.changeStateProccessedByServer;
  },
  splitted: (state) => {
    return state.splitted;
  },
  splitReason: (state) => {
    return state.splitReason;
  },
  sender: (state) => {
    return state.sender;
  },
  senderAddress: (state) => {
    return state.senderAddress;
  },
  shippingLoadingAddress: (state) => {
    return {
      id: state.shipping.LoadingAddress.Id,
      title: state.shipping.LoadingAddress.Title,
    };
  },
  client: (state) => {
    return state.client;
  },
  phases: (state) => {
    return state.phases;
  },
  phasesWithRerouting: ({ phases }) =>
    phases.filter((phase) => phase.hasRerouting),
  phasesLoading: (state) => {
    return state.phasesLoading;
  },
  isPhaseActive: (state) => {
    return state.isPhaseActive;
  },
  lastPhase: (state) => {
    return state.lastPhase;
  },
  isPhasesDone: (state) => {
    return state.isPhasesDone;
  },
  isNonStandartExist: (state) => {
    return state.isNonStandartExist;
  },
  releaseOrders: (state) => {
    return state.releaseOrders;
  },
  releaseOrdersLoading: (state) => {
    return state.releasOrdersLoading;
  },
  isReleaseOrderActive: (state) => {
    return state.isReleaseOrderActive;
  },
  isClient: (state) => {
    return state.isClient;
  },
  compactMode: (state) => {
    return state.compactMode;
  },
  sameRegionShipping: (state) => {
    return state.sameRegionShipping;
  },
  phasesHeaders: (state) => {
    return state.phasesHeaders;
  },
  releaseOrdersHeaders: (state) => {
    return state.releaseOrdersHeaders;
  },
  datesHeaders: (state) => {
    return state.datesHeaders;
  },
  senderTypeItems: () => {
    return [
      {
        value: unloadingPlaceTypes.FACTORY,
        text: "Склад продавца",
      },
      {
        value: unloadingPlaceTypes.GROUPEDWAREHOUSE,
        text: "Группажный склад",
      },
      {
        value: unloadingPlaceTypes.ADDRESS,
        text: "Другое",
      },
      {
        value: unloadingPlaceTypes.OTHERWAREHOUSE,
        text: "Другой склад",
      },
    ];
  },
  allowedStates: (state) => {
    return state.allowedStates;
  },
  isInRoute: (state) => {
    return state.isInRoute;
  },
  goodsDetails: (state) => {
    return state.goodsDetails;
  },
  disabledState: (state) => {
    return state.disabledState;
  },
  isSplited: (state) => {
    return state.isSplited;
  },
  ourWarehouse: (state) => {
    return state.ourWarehouse;
  },
  warehouseKievVolume: (state) => {
    return state.warehouseKievVolume;
  },
  packages: (state) => {
    return state.packages;
  },
  contactsLoading: (state) => {
    return state.contactsLoading;
  },
  manager: (state) => {
    return state.manager;
  },
  hasPickUpPhaseInRoute: (state) => {
    return state.hasPickUpPhaseInRoute;
  },
  isAllowEditPhase: (state) => {
    return state.isAllowEditPhase;
  },
  isPhaseInCar: (state) => {
    return state.isPhaseInCar;
  },
  categoriesInfo: (state) => {
    return state.categoriesInfo;
  },
  firstPhaseAllowEditing: (state) => {
    return state.firstPhaseAllowEditing;
  },
};

const mutations = {
  setId(state, value) {
    state.id = value;
  },
  setShipping(state, item) {
    state.shipping = item;
  },
  setInfoLoaded(state, value) {
    state.infoLoaded = value;
  },
  setInfoShipping(state, items) {
    state.infoItems = items;
  },
  setMessages(state, items) {
    state.messages = items;
  },
  setMessagesLoaded(state, value) {
    state.messagesLoaded = value;
  },
  setNotes(state, items) {
    state.notes = items;
  },
  setNotesLoaded(state, value) {
    state.notesLoaded = value;
  },
  setAttachments(state, items) {
    state.attachments = items;
  },
  setAttachmentsForExport(state, value) {
    state.attachmentsForExport = value;
  },
  setLabels(state, items) {
    state.labels = items;
  },
  setDates(state, items) {
    state.dates = items;
  },
  setVersions(state, items) {
    state.versions = items;
  },
  setVersionsLoaded(state, value) {
    state.versionsLoaded = value;
  },
  setDirection(state, item) {
    state.direction = item;
  },
  setState(state, item) {
    state.state = item;
  },
  setStateProccessedByServer(state, item) {
    state.changeStateProccessedByServer = item;
  },
  setSplitted(state, value) {
    state.splitted = value;
  },
  setSplitReason(state, splitReason) {
    state.splitReason = splitReason;
  },
  setPhases(state, items) {
    state.phases = items;
  },
  setPhasesLoading(state, value) {
    state.phasesLoading = value;
  },
  setIsPhaseActive(state, value) {
    state.isPhaseActive = value;
  },
  setLastPhase(state, item) {
    state.lastPhase = item;
  },
  setIsPhasesDone(state, value) {
    state.isPhasesDone = value;
  },
  setIsNonStandartExist(state, value) {
    state.isNonStandartExist = value;
  },
  setReleaseOrders(state, items) {
    state.releaseOrders = items;
  },
  setReleaseOrdersLoading(state, value) {
    state.releasOrdersreleasOrdersLoading = value;
  },
  setIsReleaseOrderActive(state, value) {
    state.isReleaseOrderActive = value;
  },
  setClient(state, item) {
    state.client = item;
  },
  setSender(state, item) {
    state.sender = item;
  },
  setSenderAddress(state, item) {
    state.senderAddress = item;
  },
  setIsClient(state, value) {
    state.isClient = value;
  },
  setCompactMode(state, value) {
    state.compactMode = value;
  },
  setSameRegionShipping(state, value) {
    state.sameRegionShipping = value;
  },
  setShippingStates(state, value) {
    state.shippingStates = value;
  },
  setAllowedStates(state, value) {
    state.allowedStates = value;
  },
  setIsInRoute(state, value) {
    state.isInRoute = value;
  },
  setGoodsDetails(state, value) {
    state.goodsDetails = value;
  },
  setDisabledState(state, value) {
    state.disabledState = value;
  },
  setIsSplited(state, value) {
    state.isSplited = value;
  },
  setOurWarehouse(state, value) {
    state.ourWarehouse = value;
  },
  setWarehouseKievVolume(state, value) {
    state.warehouseKievVolume = value;
  },
  setPackages(state, value) {
    state.packages = value;
  },
  setContactsLoading(state, value) {
    state.contactsLoading = value;
  },
  setManager(state, value) {
    state.manager = value;
  },
  setHasPickUpPhaseInRoute(state, value) {
    state.hasPickUpPhaseInRoute = value;
  },
  setIsAllowEditPhase(state, value) {
    state.isAllowEditPhase = value;
  },
  setIsPhaseInCar(state, value) {
    state.isPhaseInCar = value;
  },
  setCategoriesInfo(state, value) {
    state.categoriesInfo = value;
  },
  setFirstPhaseAllowEditing(state, value) {
    state.firstPhaseAllowEditing = value;
  },
};

const actions = {
  async getShipping({ dispatch, commit }, id) {
    commit("setInfoLoaded", false);
    const result = await shippingsApi.getShipping(id);
    // debugger
    const shippingStates = await shippingsApi.getShippingStates();
    if (result.data.State.Id === eShippingStates.New) {
      await shippingsApi.acceptToProcess(id);
      commit("setState", eShippingStates.InProcess);
    } else {
      commit("setState", result.data.State.Id);
    }
    commit("setIsInRoute", !!result.data.Route);
    commit("setShippingStates", shippingStates);
    dispatch("getContactsLoading", result.data.ContactsLoading);
    dispatch("updateInfo", result.data);
    dispatch("updateLabels", result.data);
    dispatch("updateAttachments", result.data);
    dispatch("updateAttachmentsForExport", result.data);
    dispatch("updateMessages", result.data);
    dispatch("updateNotes", result.data);
    dispatch("updateVersions", result.data);
    dispatch("updateSender", result.data);
    commit("setClient", {
      id: result.data.Client.Id,
      title: result.data.Client.Title,
    });
    commit("setId", result.data.Id);
    commit("setShipping", result.data);
    commit(
      "setDirection",
      result.data.Direction
        ? { id: result.data.Direction.Id, title: result.data.Direction.Title }
        : null
    );
    commit("setSplitReason", result.data.SplitReason);
    commit("setInfoLoaded", true);
    commit("setSenderAddress", {
      id: result.data.LoadingAddress.Id,
      title: result.data.LoadingAddress.Title,
    });
    commit("setIsSplited", result.data.SplitReason);
    commit("setWarehouseKievVolume", result.data.WarehouseKievVolume);
    commit(
      "setManager",
      result.data.Manager
        ? { id: result.data.Manager.Id, title: result.data.Manager.Title }
        : null
    );
    await dispatch("updateDates", id);
    await dispatch("getOurWarehouse");
    await dispatch("updatePackagesLabel", {
      packages: result.data.Packages,
      author: result.data.PackageTypeAuthor,
    });
    await dispatch("getGoodsDetails", id);
    await dispatch("getCategoriesInfo", id);
  },
  updateInfo({ commit, getters }, data) {
    const scale = 3;
    if (!data) {
      return [];
    }
    const items = [
      {
        title: "",
        items: [
          {
            title: "Дата создания",
            value: data.Date,
            type: "date",
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Автор заявки",
            value: data.Author ? data.Author.Title : "",
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Пользователь Кабинета",
            value: data.AuthorContactPerson
              ? data.AuthorContactPerson.Title
              : "",
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Клиент",
            value: data.Client ? data.Client.Title : "",
            showAlways: true,
          },
          {
            title: "Клиент по документам",
            value: data.ClientAlias,
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Менеджер",
            value: data.Manager.Title,
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Внутренний номер заявки у клиента",
            value: data.InternalRequestNumber,
            showAlways: true,
            roles: ["client"],
          },
        ],
      },
      {
        title: "Первоначальное местонахождение груза",
        items: [
          {
            title: "Страна отправления",
            value: data.Country.Title,
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Квадрат",
            value: data.LoadingAddress ? data.LoadingAddress.Postcode : "",
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Продавец",
            value: data.SenderFactory
              ? data.SenderFactory.Title
              : data.SenderWarehouse
                ? data.SenderWarehouse.Title
                : data.SenderAddress
                  ? data.SenderAddress.Title
                  : "",
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Производитель",
            type: "string-list",
            value: data.Manufacturer,
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Адрес погрузки",
            value: data.LoadingAddress.Title,
            showAlways: false,
            roles: ["client"],
          },
          {
            title: "",
            type: "array",
            value: getters.contactsLoading,
            showAlways: false,
            roles: ["client"],
          },
          {
            title: "Время работы места погрузки",
            value: data.LoadingPlaceTimetable,
            showAlways: false,
            roles: ["client"],
          },
          {
            title: "Комментарии по погрузке",
            value: data.CargoComment,
            showAlways: false,
            roles: ["client"],
          },
          {
            title: "Комментарии к поставке",
            value: data.CommentForShipping,
            showAlways: false,
            roles: ["client"],
          },
        ],
      },
      {
        title: "Информация о товаре",
        event: "goods-details",
        items: [
          {
            title: "Описание товара",
            value: data.ProductDescription,
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Категория товара",
            type: "string-list",
            value: data.ProductCategory,
            showAlways: true,
            roles: ["client"],
            event: "categories-info",
          },
          {
            title: "Стоимость партии груза",
            value: data.InvoiceSumGoodsDetails
              ? `${data.InvoiceSumGoodsDetails} ${data.Currency.Title} (Описание товаров)`
              : `${data.InvoiceSum} ${data.Currency.Title}`,
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Валюта",
            value: data.Currency.Title,
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Менеджер по описанию",
            value: data.ManagerByDescription
              ? data.ManagerByDescription.Title
              : "",
            showAlways: false,
          },
          {
            title: "Референс погрузки",
            value: data.LoadingNumber
              ? data.LoadingNumber.replace(/\n/g, "; ")
              : "",
            showAlways: false,
            roles: ["client"],
          },
          {
            title: "Маркировка на фабрике",
            type: "string-list",
            value: data.ProductFactoryMarkings,
            showAlways: false,
            roles: ["client"],
          },
        ],
      },
      {
        title: "Адрес доставки товара",
        items: [
          {
            title: "Тип поставки",
            value: data.ShippingType.Title,
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Страна-получатель по докам фабрики/отправителя",
            value: data.DestinationCountry.Title,
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Страна",
            value: data.UnloadingCountry.Title,
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Город",
            value: data.UnloadingCity.Title,
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Адрес",
            value: data.UnloadingAddress.Title,
            showAlways: false,
            roles: ["client"],
          },
          {
            title: "Контактное лицо выгрузки",
            value:
              data.ContactsUnloading &&
              data.ContactsUnloading.length &&
              data.ContactsUnloading[0].ContactPerson.Title
                ? data.ContactsUnloading[0].ContactPerson.Title
                : "",
            showAlways: false,
            roles: ["client"],
          },
          {
            title: "Контактный номер телефона",
            value:
              data.ContactsUnloading &&
              data.ContactsUnloading.length &&
              data.ContactsUnloading[0].ContactPhone
                ? `+${data.ContactsUnloading[0].ContactPhone}`
                : "",
            showAlways: false,
            roles: ["client"],
          },
        ],
      },
      {
        title: "Характеристики товара",
        event: "goods-summary",
        items: [
          {
            title: "Объем, м3",
            value: data.WarehouseKievVolume
              ? `${data.WarehouseKievVolume.toFixed(scale).replace(
                ".",
                ","
              )} (Киев)`
              : data.WarehouseDetailsVolume
                ? `${data.WarehouseDetailsVolume.toFixed(scale).replace(
                  ".",
                  ","
                )} (Склад)`
                : data.GoodsDetailsVolume
                  ? `${data.GoodsDetailsVolume.toFixed(scale).replace(
                    ".",
                    ","
                  )} (Документы)`
                  : `${data.Volume.toFixed(scale).replace(".", ",")} (Заявка)`,
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Вес брутто, кг",
            value: data.WarehouseKievWeight
              ? `${data.WarehouseKievWeight.toFixed(scale).replace(
                ".",
                ","
              )} (Киев)`
              : data.WarehouseDetailsWeight
                ? `${data.WarehouseDetailsWeight.toFixed(scale).replace(
                  ".",
                  ","
                )} (Склад)`
                : data.GoodsDetailsWeight
                  ? `${data.GoodsDetailsWeight.toFixed(scale).replace(
                    ".",
                    ","
                  )} (Документы)`
                  : `${data.Weight.toFixed(scale).replace(".", ",")} (Заявка)`,
            type: "digit",
            showAlways: true,
            roles: ["client"],
          },
        ],
      },
      {
        title: "Доп. инфо в Заявке",
        lastGroup: true,
        items: [
          {
            title: "Нужна ли EX?",
            value: data.NeedEx.Title,
            showAlways: false,
            roles: ["client"],
          },

          {
            title: "Срочность",
            value: data.StartUrgency.Title,
            showAlways: false,
            roles: ["client"],
          },

          {
            title: "Способ упаковки",
            value: data.StartPackingMethod ? "Паллеты" : "Не паллеты",
            showAlways: false,
            roles: ["client"],
          },
          {
            title: "Негабарит",
            value: data.StartOversized ? "Да" : "Нет",
            showAlways: false,
            roles: ["client"],
          },
          {
            title: "Груз оплачен",
            value: data.StartIsPayed ? "Да" : "Нет",
            showAlways: false,
            roles: ["client"],
          },
          {
            title: "Готовность Заявка",
            value: data.ReadyDate,
            type: "date",
            showAlways: true,
            roles: ["client"],
          },
          {
            title: "Доставка Заявка",
            value: { from: data.WantedDateFrom, to: data.WantedDateTo },
            type: "dateRange",
            showAlways: true,
            roles: ["client"],
          },
        ],
      },
    ];
    commit("setInfoShipping", items);
  },
  async updateDates({ commit }, id) {
    const routeDates = await shippingsApi.getShippingRouteDates(id);
    const dates = {
      readyToLoadDates: {
        request: routeDates.data.ReadyDate,
        plan: routeDates.data.ReadyForShipmentPlan,
        fact: routeDates.data.ReadyForShipmentFact,
      },
      dateOfExportFromFactory: {
        request: "",
        plan: routeDates.data.DateOfExportFromFactoryPlan,
        fact: routeDates.data.DateOfExportFromFactoryFact,
      },
      factoryClosing: {
        request: routeDates.data.FactoryClosingRequestDate,
        plan: routeDates.data.FactoryClosingPlan,
        fact: routeDates.data.FactoryClosingFact,
      },
      wantedDates: {
        request: {
          dateFrom: routeDates.data.WantedDateFrom,
          dateTo: routeDates.data.WantedDateTo,
        },
        plan: routeDates.data.DesiredDeliveryDatePlan,
        fact: "",
      },
      deliveryToUnloading: {
        request: "",
        plan: routeDates.data.DeliveryToUnloadingPlacePlan,
        fact: routeDates.data.DeliveryToUnloadingPlaceFact,
      },
      shipmentFromStoreKiev: {
        request: "",
        plan: routeDates.data.ReleaseOrderPlanDates,
        fact: routeDates.data.ReleaseOrderFactDates,
      },
    };
    commit("setDates", dates);
  },
  updateLabels({ commit }, data) {
    if (!data) {
      return;
    }
    const labels = [
      {
        name: "urgency",
        value: data.Urgency,
        author: data.UrgencyAuthor,
      },
      {
        name: "multimodal",
        value: data.Multimodal,
        author: data.MultimodalAuthor,
        disabled: false,
      },
      {
        name: "invoice",
        value: data.Invoice,
        author: data.InvoiceAuthor,
      },
      {
        name: "ex",
        value: [
          {
            name: "exWhoDoing",
            value: data.Ex.ExWhoDoing,
          },
          {
            name: "exDocumentInSystem",
            value: data.Ex.ExDocumentInSystem,
          },
        ],
        author: data.ExAuthor,
        group: true,
      },
      {
        name: "description",
        value: data.Description,
        author: data.DescriptionAuthor,
      },
      {
        name: "damage",
        value: data.Damage,
        author: data.DamageAuthor,
      },
      {
        name: "attention",
        value: data.Attention,
        author: data.AttentionAuthor,
      },
      {
        name: "oversized",
        value: data.Oversized,
        author: data.OversizedAuthor,
      },
      {
        name: "fragile",
        value: data.Fragile,
        author: data.FragileAuthor,
      },
      {
        name: "mesurable",
        value: data.Mesurable,
        author: data.MesurableAuthor,
        disabled: data.Accepted,
        tooltip:
          "Запрещено менять метку обмер груза. Сформирован приходный ордер.",
      },
      {
        name: "giveAway",
        value: data.GiveAway,
        author: data.GiveAwayAuthor,
      },
      {
        name: "cargoRepacked",
        value: data.CargoRepacked,
        author: data.CargoRepackedAuthor,
      },
      {
        name: "claim",
        value: data.Claim,
        author: data.ClaimAuthor,
      },
      {
        name: "isPayed",
        value: data.IsPayed,
        author: data.IsPayedAuthor,
      },
      {
        name: "parseByOrders",
        value: data.ParseByOrders,
        author: data.ParseByOrdersAuthor,
        disabled: data.Accepted,
        tooltip: "Запрещено менять метку. Сформирован приходный ордер.",
      },
    ];
    commit("setLabels", labels);
  },
  updateAttachments({ commit }, data) {
    if (!data) {
      return;
    }
    const attachments = data.Attachments.map((a) => {
      return {
        id: a.Id,
        title: a.Title,
        accessibleInCabinet: a.AccessibleInCabinet,
      };
    });
    commit("setAttachments", attachments);
  },
  updateAttachmentsForExport({ commit }, data) {
    if (!data) {
      return;
    }
    const attachmentsForExport = data.AttachmentsForExport.map((a) => {
      return {
        id: a.Id,
        title: a.Title,
        accessibleInCabinet: a.AccessibleInCabinet,
      };
    });
    commit("setAttachmentsForExport", attachmentsForExport);
  },
  updateMessages({ commit }, data) {
    if (!data) {
      return;
    }
    const messages = data.Messages.map((n) => {
      return {
        id: n.Id,
        text: n.Text,
        date: n.CreatedAt,
        author: n.Author
          ? {
            id: n.Author.Id,
            title: n.Author.Title,
          }
          : null,
        authorContactPerson: n.AuthorContactPerson
          ? {
            id: n.AuthorContactPerson.Id,
            title: n.AuthorContactPerson.Title,
          }
          : null,
        isReaded: n.IsReaded,
        readedContactPerson: n.ReadedContactPerson
          ? {
            id: n.ReadedContactPerson.Id,
            title: n.ReadedContactPerson.Title,
          }
          : null,
        readedDate: n.ReadedDate,
        source: n.Source,
      };
    });
    commit("setMessages", messages);
  },
  updateNotes({ commit }, data) {
    if (!data) {
      return;
    }
    const notes = data.Notes.map((n) => {
      return {
        id: n.Id,
        text: n.Text,
        date: n.ChangedAt,
        author: n.Author,
      };
    });
    commit("setNotes", notes);
  },
  updateVersions({ commit }, data) {
    commit("setVersionsLoaded", false);
    if (!data) {
      return;
    }
    const versions = data.Versions.map((v) => {
      return {
        id: v.Id,
        title:
          v.Id === 0 ? v.Title : `${v.Title} от ${v.CreatedAt} (${v.Author})`,
        date: v.CreatedAt,
        author: v.Author,
      };
    });
    versions.unshift({
      id: 0,
      title: `Версия ${versions.length + 1} (актуальная)`,
    });
    commit("setVersions", versions);
    commit("setVersionsLoaded", true);
  },
  async getMessages({ commit, state }) {
    commit("setMessagesLoaded", false);
    const messages = await shippingsApi.getMessages(state.id);
    commit("setMessages", messages);
    commit("setMessagesLoaded", true);
  },
  async getNotes({ commit, state }) {
    commit("setNotesLoaded", false);
    const notes = await shippingsApi.getNotes(state.id);
    commit("setNotes", notes);
    commit("setNotesLoaded", true);
  },
  updateSender({ commit }, data) {
    if (data.SenderWarehouse) {
      commit("setSender", changeSender(data.SenderWarehouse, 1));
    }
    if (data.SenderFactory && !data.SenderWarehouse) {
      commit("setSender", changeSender(data.SenderFactory, 0));
    }
    if (data.SenderAddress) {
      commit("setSender", changeSender(data.SenderAddress, 2));
    }

    function changeSender(data, type) {
      return {
        id: data.Id,
        title: data.Title,
        type,
      };
    }
  },
  async getPhases({ commit, dispatch }, id) {
    commit("setPhasesLoading", true);
    const phases = await getPhases(id);
    const index = phases.indexOf(
      phases.find((p) => p.state.id === phaseStates.AWAITING)
    );
    phases.forEach((p, ind) => {
      if (index != -1 && ind > index) {
        p.disabledState = true;
      } else {
        p.disabledState = false;
      }
    });
    commit("setPhases", phases);
    const pickUpPhaseInRoute = !!phases.find(
      (p) =>
        p.type.id === ePhaseTypes.PICKUP && p.state.id === phaseStates.INROUTE
    );
    commit("setHasPickUpPhaseInRoute", pickUpPhaseInRoute);
    const isAllowEdit = !!phases.some((p) => p.allowEditing);
    const isInCar = phases.some((p) => p.inCar);
    const firstPhaseAllowEditing = !!phases.find((p, index) => {
      if (index === 0) {
        return p.allowEditing;
      }
    });
    commit("setIsAllowEditPhase", isAllowEdit);
    commit("setIsPhaseInCar", isInCar);
    commit("setFirstPhaseAllowEditing", firstPhaseAllowEditing);
    dispatch("updateExistNonStandartPhase");
    commit("setPhasesLoading", false);
  },
  updateExistNonStandartPhase({ commit, state }) {
    const nonStandartPhase = state.phases.find((phase) => {
      return phase.type.id === 2;
    });
    if (nonStandartPhase) {
      commit("setIsNonStandartExist", true);
    } else {
      commit("setIsNonStandartExist", false);
    }
  },
  async getReleaseOrders({ commit }, id) {
    commit("setReleaseOrdersLoading", true);
    const releaseOrders = await shippingsApi.getReleaseOrders(id);
    commit("setReleaseOrders", releaseOrders);
    commit("setReleaseOrdersLoading", false);
  },
  getShippingStateById(state) {
    return (id) => {
      return state.shippingStates.find((item) => item.id === id);
    };
  },
  async changeState({ commit }, params) {
    commit("setStateProccessedByServer", true);
    switch (params.state) {
      case eShippingStates.NotAccepted:
        {
          await shippingsApi.revoke(params.id);
        }
        break;
      case eShippingStates.InProcess:
        {
          await shippingsApi.acceptToProcess(params.id);
        }
        break;
      case eShippingStates.CanceledByClient:
        {
          await shippingsApi.cancelByClient(params.id);
        }
        break;
    }
    commit("setState", params.state);
    commit("setStateProccessedByServer", false);
  },
  async restore({ commit, dispatch }, params) {
    commit("setStateProccessedByServer", true);
    await shippingsApi.restore(params.id);
    commit("setStateProccessedByServer", false);
    await dispatch("getShipping", params.id);
  },
  async getGoodsDetails({ commit }, id) {
    const result = await shippingsApi.getGoodsDetails(id);
    commit("setGoodsDetails", result);
  },
  async getOurWarehouse({ commit }) {
    const warehouse = await getSettings();
    const address = await getData(
      "warehouses",
      false,
      warehouse.data.Warehouse.Id
    );
    commit("setOurWarehouse", {
      warehouse: warehouse.data.Warehouse
        ? {
          id: warehouse.data.Warehouse.Id,
          title: warehouse.data.Warehouse.Title,
        }
        : null,
      address: address.data.Address
        ? {
          id: address.data.Address.Id,
          title: address.data.Address.Title,
        }
        : null,
    });
  },
  async unmarkPhasesWithRerouting(
    { getters, commit },
    { phaseId, shippingId }
  ) {
    await unmarkPhasesWithRerouting(shippingId, phaseId);
    const phaseItems = getters.phases;
    phaseItems.forEach((p) => {
      if (p.id === phaseId) {
        p.hasRerouting = false;
      }
    });
    commit("setPhases", phaseItems);
  },
  updatePackagesLabel({ commit }, value) {
    let packages = [];
    if (
      (Array.isArray(value.packages) && !value.packages.length) ||
      (typeof value.packages === "object" && !value.packages)
    ) {
      commit("setPackages", packages);
      return;
    }
    packages = {
      author: value.author,
      value: value.packages.map((p) => {
        return {
          id: p.Id,
          packageTypeId: p.PackageType.Id,
          title: p.PackageType.Title,
          shortTitle: p.PackageType.ShortTitle,
          color: p.PackageType.Color,
          width: p.Width,
          height: p.Height,
          length: p.Length,
          quantity: p.Quantity,
        };
      }),
    };
    commit("setPackages", packages);
  },
  getContactsLoading({ commit }, items) {
    if (!items.length) {
      commit("setContactsLoading", [
        [
          { title: "Контактное лицо погрузки", value: null },
          { title: "Контактный номер телефона", value: null },
          { title: "Контактный e-mail", value: null },
        ],
      ]);
      return;
    }
    let contact = [];
    const contacts = [];
    items.forEach((i) => {
      for (const key in i) {
        if (key === "ContactPerson") {
          contact = [];
          const person = {};
          person.title = "Контактное лицо погрузки";
          person.value = i.ContactPerson?.Title || "";
          contact.push(person);
        } else if (key === "ContactPhone") {
          const phone = {};
          phone.title = "Контактный номер телефона";
          phone.value = i.ContactPhone;
          contact.push(phone);
        } else if (key === "ContactEmail") {
          const email = {};
          email.title = "Контактный e-mail";
          email.value = i.ContactEmail;
          contact.push(email);
        }
      }
      contacts.push(contact);
      commit("setContactsLoading", contacts);
    });
  },
  async getCategoriesInfo({ commit }, id) {
    const result = await shippingsApi.getCategoriesInfo(id);
    commit("setCategoriesInfo", result);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
